import { render, staticRenderFns } from "./QuestionNumber.vue?vue&type=template&id=3db14abe"
import script from "./QuestionNumber.vue?vue&type=script&lang=js"
export * from "./QuestionNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports